import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate, useLocation } from "react-router-dom";
// import { useUser } from "../context/UserContext";

export default function FloatingCart() {
  const location = useLocation();
  const { cartItems, clearCart, updateCartItemQuantity, removeItemFromCart } =
    useCart();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  // const { user } = useUser();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const hiddenRoutes = ["/checkout", "/login", "/order-success"];
  if (hiddenRoutes.includes(location.pathname)) return null;

  if (cartItems.length === 0) return null;

  const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cartItems
    .reduce((sum, item) => sum + (item.totalPrice || 0), 0)
    .toFixed(2);

  const handleCheckoutClick = () => {
    // setIsOpen(false);
    // if (!user?.token) {
    //   sessionStorage.setItem("redirectAfterLogin", "/checkout");
    //   navigate("/login");
    //   return;
    // }
    navigate("/checkout");
  };

  return (
    <div
      className="
        fixed bottom-4 sm:bottom-6
        left-0 sm:left-1/2 sm:-translate-x-1/2
        w-full
        px-3 sm:px-0
        sm:max-w-xl
        z-50 pointer-events-auto
      "
    >
      {/* Sliding Cart Panel */}
      <div
        className={`
    absolute bottom-full
    left-0 sm:left-1/2
    w-full sm:max-w-xl
    sm:-translate-x-1/2
    px-3 sm:px-0
    transition-all duration-300 ease-in-out
    ${isOpen ? "max-h-[85vh] opacity-100" : "max-h-0 opacity-0 overflow-hidden"}
  `}
        style={{ zIndex: 60 }}
      >
        <div className="bg-slate-900 rounded-2xl p-4 sm:p-6 flex flex-col shadow-2xl border border-slate-800 max-h-[85vh]">
          {/* ONLY THIS LIST SCROLLS */}
          <div className="flex-1 overflow-y-auto pr-1 flex flex-col gap-3">
            {cartItems.map((cartItem) => {
              const {
                item,
                quantity,
                key,
                selectedRequiredOption,
                selectedOptionalOptions,
              } = cartItem;

              const options = [];
              if (selectedRequiredOption) options.push(selectedRequiredOption);
              if (selectedOptionalOptions?.length)
                options.push(...selectedOptionalOptions);

              return (
                <div
                  key={key}
                  className="flex justify-between items-start p-3 rounded-xl bg-slate-800 gap-3"
                >
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-white truncate">
                      {item.item_name}
                    </p>

                    {options.map((opt, idx) => (
                      <p
                        key={idx}
                        className="text-sm text-slate-300 ml-2 truncate"
                      >
                        {opt.option_name}{" "}
                        {opt.quantity > 1 ? `x${opt.quantity}` : ""}
                      </p>
                    ))}
                  </div>

                  <div className="flex flex-col items-end gap-2 shrink-0">
                    <span className="font-bold text-white">
                      £{(cartItem.totalPrice || 0).toFixed(2)}
                    </span>

                    <div className="flex items-center gap-2 mt-2">
                      <button
                        onClick={() =>
                          updateCartItemQuantity(key, Math.max(1, quantity - 1))
                        }
                        className="px-2 font-bold text-slate-300 hover:text-orange-500 rounded bg-slate-700"
                      >
                        −
                      </button>
                      <span className="w-6 text-center text-white">
                        {quantity}
                      </span>
                      <button
                        onClick={() =>
                          updateCartItemQuantity(key, quantity + 1)
                        }
                        className="px-2 font-bold text-slate-300 hover:text-orange-500 rounded bg-slate-700"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={() => removeItemFromCart(key)}
                    className="text-red-500 font-bold hover:text-red-600 ml-2 shrink-0"
                    aria-label="Remove item"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>

          {/* FIXED FOOTER */}
          <div className="pt-3 border-t border-slate-700 mt-3">
            <div className="flex justify-between items-center font-bold text-base sm:text-lg text-white">
              <span>Total</span>
              <span>£{totalPrice}</span>
            </div>

            <button
              onClick={handleCheckoutClick}
              className="w-full bg-primary hover:bg-orange-600 text-white font-bold py-3 rounded-xl transition-all transform active:scale-95 mt-3"
            >
              Checkout
            </button>
          </div>
        </div>
      </div>

      {/* Floating Cart Bar */}
      <div className="relative bg-slate-900 text-white rounded-2xl shadow-2xl border border-white/10">
        <div className="p-3 sm:p-4 flex items-center justify-between gap-2 sm:gap-3">
          {/* Left: icon + basket info */}
          <div className="flex items-center gap-2 sm:gap-3 min-w-0">
            <div className="relative shrink-0">
              <div className="w-9 h-9 sm:w-12 sm:h-12 bg-primary rounded-xl flex items-center justify-center">
                <span className="material-icons text-[18px] sm:text-[24px]">
                  shopping_bag
                </span>
              </div>

              {totalQuantity > 0 && (
                <span className="absolute -top-2 -right-2 bg-white text-primary text-[10px] sm:text-xs font-bold w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center shadow-lg">
                  {totalQuantity}
                </span>
              )}
            </div>

            <div className="min-w-0 leading-tight ml-3">
              <p className="text-[11px] sm:text-xs text-slate-300 font-medium truncate">
                Your Basket
              </p>
              <p className="font-bold text-base sm:text-lg truncate">
                £{totalPrice}
              </p>
            </div>
          </div>

          {/* Right: Clear + View Basket */}
          <div className="flex items-center gap-6 sm:gap-6 shrink-0">
            <button
              onClick={clearCart}
              className="text-[12px] sm:text-base font-semibold text-slate-300 hover:text-white transition-colors"
            >
              Clear
            </button>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="
          bg-primary hover:bg-primary/90 text-white font-bold
          px-3 sm:px-6 py-2.5 sm:py-3
          rounded-xl flex items-center gap-2
          transition-all transform active:scale-95
          text-[12px] sm:text-base
          whitespace-nowrap
        "
            >
              {isOpen ? "Close" : "Open"}
              <span className="material-icons text-[14px] sm:text-sm">
                arrow_forward_ios
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
